export default {
  workflowApps: (state = [], action) => {
    switch (action.type) {
      case 'setWorkflowApps':
        return action.payload;

      default:
        return state;
    }
  },
};
